import React from 'react';
import { connect } from 'react-redux';
import { Tab, Nav, Col, Badge } from 'react-bootstrap';
import { Filter, FilterBox } from '../widgets';
import { GEO_FIELD_TYPE } from '../../constants';

class GeoRegionFilter extends React.Component {
    constructor(props) {
        super(props);

        this.default = {
            fieldType: []
        };

        this.state = {
            ...this.default,
            isOpen: false,
            filters: { ...this.default },
            previous: { ...this.default }
        }

        this.handleApply = this.handleApply.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.toggle = this.toggle.bind(this);
        this.getFilterCount = this.getFilterCount.bind(this);
    }

    componentDidMount() {
        this.setState({
            fieldType: GEO_FIELD_TYPE.map(({ id, name: label }) => ({ id, label }))
        });
    }

    handleSelect(item, e, name) {
        const id = item.id;
        const { checked } = e.target;
        const selected = [...this.state.filters[name]];
        const indexOf = selected.indexOf(id);
        if (checked && indexOf < 0) selected.push(id);
        else if (!checked && indexOf >= 0) selected.splice(indexOf, 1);
        this.setState({ filters: { ...this.state.filters, [name]: selected } });
    }

    handleApply() {
        const { filters } = this.state;
        let foundItems = this.props.regionsList;

        if (filters.fieldType.length > 0)
            foundItems = foundItems.filter(e => filters.fieldType.indexOf(e.geo_region_type_id) >= 0);

        this.props.onFilter(foundItems.map(e => e.geo_region_uuid));
        this.setState({ isOpen: false, previous: this.state.filters });
    }

    handleClear() {
        this.props.onFilter(null);
        this.setState({ filters: { ...this.default }, previous: { ...this.default } });
    }

    toggle(isOpen) {
        if (!isOpen && this.state.isOpen)
            this.setState({ isOpen, filters: { ...this.state.previous } });
        else this.setState({ isOpen });
    }

    getFilterCount(name) {
        if (name)
            return this.state.filters[name].length > 0 ? this.state.filters[name].length : '';
        else {
            let total = 0;
            for (const key in this.state.filters) total += (this.state.filters[key].length > 0 ? 1 : 0);
            return total > 0 ? total : null;
        }
    }

    render() {
        const totalFilters = this.getFilterCount();

        return (
            <Filter show={this.state.isOpen} onToggle={this.toggle} className="geo-filter">
                <Filter.Toggle>
                    {totalFilters && <Badge variant="warning" className="badge-filter-count">{totalFilters}</Badge>}
                </Filter.Toggle>
                <FilterBox>
                    <Tab.Container defaultActiveKey="first">
                        <FilterBox.Body>
                            <Col sm={5} className="mt-2 pr-1">
                                <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                        <Nav.Link eventKey="first">
                                            Field type
                                            <span className="filter-count">{this.getFilterCount("fieldType")}</span>
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col lg={7}>
                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <Filter.Options options={this.state.fieldType}
                                            selected={this.state.filters.fieldType}
                                            keyname={{ value: "id", label: "label" }}
                                            onSelect={(item, e) => this.handleSelect(item, e, "fieldType")}
                                        />
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </FilterBox.Body>
                        <FilterBox.Footer>
                            <Filter.ClearButton onClick={this.handleClear} />
                            <Filter.ApplyButton onClick={this.handleApply} />
                        </FilterBox.Footer>
                    </Tab.Container>
                </FilterBox>
            </Filter>
        )
    }
}

const mapStateToProps = (state) => ({
    regionsList: state.geo.regionsList
});

export default connect(mapStateToProps, null)(GeoRegionFilter);